import { Flex } from '@chakra-ui/react';

import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import { RevelioPageId } from '../PageConfigProvider/types';
import { useTableSelection } from '../TableSelectionProvider/TableSelectionProvider';
import { TalentDiscoverySourceWhaleButton } from '../TableSelectionProvider/TalentDiscoverySourceWhaleButton';

export const CustomDashActionBar = () => {
  const { revelioPageId } = useTabContentConfig();
  const { selectedRows } = useTableSelection();

  return (
    <Flex alignItems="center" gap={4}>
      {revelioPageId === RevelioPageId.TALENT_DISCOVERY && (
        <TalentDiscoverySourceWhaleButton selectedRows={selectedRows ?? []} />
      )}
    </Flex>
  );
};
